import { useMutation } from "@tanstack/react-query";
import { useContext } from "react";
import { AlertBannerContext } from "@kivunova/kivufrontendcommon";
import { fetchGraphQL } from "../../Graphql/utils";
import {
  listSuperAdminsQuery,
  updateSuperAdminStatusMutation,
  updateSuperAdminRoleMutation,
} from "../../Graphql/querries/authQuery";

export interface SuperAdminUser {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  phone?: string | null;
  profileImage?: string | null;
  role?: string | null;
  status?: string | null;
  emailVerified?: boolean | null;
  passwordChangeRequired?: boolean | null;
  companyId?: string | null;
  storeId?: string | null;
}

export interface ListSuperAdminsResponse {
  listSuperAdmins: {
    code: string;
    users: SuperAdminUser[];
  };
}

export interface UpdateSuperAdminStatusResponse {
  updateSuperAdminStatus: {
    code: string;
    user: SuperAdminUser | null;
  };
}

export interface UpdateSuperAdminRoleResponse {
  updateSuperAdminRole: {
    code: string;
    user: SuperAdminUser | null;
  };
}

export function useListSuperAdmins() {
  const { setAlert } = useContext(AlertBannerContext);
  return useMutation<ListSuperAdminsResponse, Error, void>({
    mutationKey: ["listSuperAdmins"],
    mutationFn: () => fetchGraphQL(listSuperAdminsQuery, {}, setAlert),
  });
}

export function useUpdateSuperAdminStatus() {
  const { setAlert } = useContext(AlertBannerContext);
  return useMutation<
    UpdateSuperAdminStatusResponse,
    Error,
    { userId: string; status: string }
  >({
    mutationKey: ["updateSuperAdminStatus"],
    mutationFn: ({ userId, status }) =>
      fetchGraphQL(
        updateSuperAdminStatusMutation,
        {
          userId,
          input: { status },
        },
        setAlert,
      ),
  });
}

export function useUpdateSuperAdminRole() {
  const { setAlert } = useContext(AlertBannerContext);
  return useMutation<
    UpdateSuperAdminRoleResponse,
    Error,
    { userId: string; role: string }
  >({
    mutationKey: ["updateSuperAdminRole"],
    mutationFn: ({ userId, role }) =>
      fetchGraphQL(
        updateSuperAdminRoleMutation,
        {
          userId,
          input: { role },
        },
        setAlert,
      ),
  });
}
